<template>
  <div v-if="element.name.toUpperCase() === 'SECTION'">
    <button type="button" class="block w-full relative" @click="toggleSectionCollapse">
      <base-heading no-margin size="lg">{{ element.pivot.label }}</base-heading>
      <chevron-right-icon class="absolute right-0 top-1/2 h-5 w-5 text-gray-400 transform -translate-y-1/2 cursor-pointer" :class="sectionExpanded ? 'rotate-90' : ''" />
    </button>
    <small v-if="element.pivot.helptext" slot="helperText" class="form-text text-muted">{{ element.pivot.helptext
    }}</small>
  </div>
  <div v-else-if="ready" v-show="!(!showDeprecated && hiddenLabels.some(l => element.pivot.label.toLowerCase().includes(l)))">
    <div class="relative">
      <base-label>{{ labelPrefix }}{{ element.pivot.label }}</base-label>
      <chevron-right-icon v-if="element.name.toUpperCase() === 'REPEATER'" @click="toggleRepeaterCollapse" class="absolute right-0 top-1/2 h-5 w-5 text-gray-400 transform -translate-y-1/2 cursor-pointer" :class="repeaterExpanded ? 'rotate-90' : ''" />
    </div>
    <bldr-components v-if="element.name.toUpperCase() === 'COMPONENTS'" v-model="data" :element="element"
      :disabled="disabled" />
    <div v-else :class="!repeaterExpanded ? 'max-h-0 overflow-hidden' : ''">
      <div v-for="(mk, idxM) in element.markup" :key="`elmk.${idxM}`">
        <bldr-field v-if="element.markup.length === 1" v-model="data" :idx="idxM" :element="element" :field="mk"
          :disabled="disabled" ref="field" @select-updated="(v) => $emit('select-updated', v)" />
        <bldr-field v-else v-model="data[idxM]" :idx="idxM" :element="element" :field="mk" :disabled="disabled"
          ref="field" @select-updated="(v) => $emit('select-updated', v)" />
      </div>
    </div>
    <small v-if="element.pivot.helptext" slot="helperText" class="form-text text-muted">{{ element.pivot.helptext
    }}</small>
  </div>
</template>
<script>
import BaseLabel from '../Form/BaseLabel'
import BldrField from './BldrField'
import { ChevronRightIcon } from '@vue-hero-icons/solid'
export default {
  name: 'BldrElement',
  components: {
    BldrComponents: () => import('./BldrComponents'),
    BldrField,
    BaseLabel,
    ChevronRightIcon,
  },
  props: {
    element: Object,
    value: {
      type: [String, Number, Array, Object, Boolean],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    labelPrefix: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ready: false,
      markup: [],
      hiddenLabels: ['deprecated', '(hidden)', 'old cms id'],
      repeaterExpanded: true,
      sectionExpanded: true,
    }
  },
  mounted() {
    this.element.markup = typeof this.element.markup === 'string' ?
      JSON.parse(this.element.markup) : this.element.markup;
    if (typeof this.element.pivot.options === 'string' && this.element.pivot.options.length) {
      this.element.pivot.options = JSON.parse(this.element.pivot.options);
    }
    if (this.element.markup.length > 1 && !this.data) {
      this.data = this.element.markup.map(() => { return '' });
    }

    if (Array.isArray(this.value) &&
      this.value.length === 1 &&
      !(this.element.name === 'Repeater' ||
        this.element.name === 'File Upload' ||
        this.element.name === 'Components' ||
        this.element.name === 'Checkboxes' ||
        this.element.name === 'Dynamic Checkboxes'
      )
    ) {
      this.data = JSON.parse(JSON.stringify(this.value[0]));
    }

    this.$nextTick(() => {
      this.ready = true;
    })
  },
  methods: {
    toggleRepeaterCollapse() {
      this.repeaterExpanded = !this.repeaterExpanded;
    },
    toggleSectionCollapse(evt) {
      console.log(evt);

      // Get parent cms-section-element
      const filter = '*';
      const sectionClass = 'cms-section-element';
      const sectionSelector = `.${sectionClass}`;
      const element = evt.target.closest(sectionSelector);
      const siblings = [];
      if (element) {
        let next = element.nextElementSibling;

        while (next && !next.matches(sectionSelector)) {
          if (next.matches(filter))
            siblings.push(next);
          next = next.nextElementSibling;
        }

        if (this.sectionExpanded) {
          this.sectionExpanded = false;
          siblings.forEach(el => {
            el.classList.add('hidden');
          })
        } else {
          this.sectionExpanded = true;
          siblings.forEach(el => {
            el.classList.remove('hidden');
          })
        }
      } else {
        console.log(siblings);
      }
    }
  },
  computed: {
    data: {
      get() { return this.value },
      set(data) { this.$emit('input', data) }
    },
    showDeprecated() {
      return this.$root.showDeprecated;
    },
  }
}
</script>
